import { NavLink, useNavigate } from "react-router-dom";
import { LogOut, User, Settings } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../lib/auth";

const link = ({ isActive }) =>
  `text-sm font-semibold px-3 py-2 rounded-md transition-colors ${
    isActive ? "text-[#0153A3] bg-[#EFF6FF]" : "text-[#1F2937] hover:bg-[#F7F9FC]"
  }`;

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => {
    await logout();
    nav("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 border-b border-[#E5E7EB] bg-white">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:h-20 sm:px-6">
        <NavLink to="/" className="flex items-center gap-2" data-testid="header-logo-link">
          <Logo className="h-12 w-auto sm:h-14" />
        </NavLink>

        <nav className="hidden items-center gap-1 sm:flex" data-testid="desktop-nav">
          <NavLink to="/" end className={link} data-testid="nav-home">Home</NavLink>
          <NavLink to="/prodotti" className={link} data-testid="nav-prodotti">Prodotti</NavLink>
          <NavLink to="/preferiti" className={link} data-testid="nav-preferiti">Preferiti</NavLink>
          <NavLink to="/impara" className={link} data-testid="nav-impara">Impara</NavLink>
          <NavLink to="/questionari" className={link} data-testid="nav-questionari">Questionari</NavLink>
          {user?.role === "ADMIN" && (
            <NavLink to="/admin" className={link} data-testid="nav-admin">Admin</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user?.role === "ADMIN" && (
            <NavLink
              to="/admin"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-[#0153A3] text-[#0153A3] hover:bg-[#EFF6FF] sm:hidden"
              aria-label="Admin"
              data-testid="header-admin-mobile-link"
            >
              <Settings size={18} />
            </NavLink>
          )}
          <div className="hidden items-center gap-2 rounded-full bg-[#F7F9FC] px-3 py-1.5 sm:flex">
            <User size={16} className="text-[#0153A3]" />
            <div className="text-xs">
              <div className="font-semibold text-[#1F2937]">{user?.name || user?.email}</div>
              <div className="text-[10px] font-bold uppercase tracking-wider text-[#0153A3]">
                {user?.role === "ADMIN" ? "ADMIN" : "ISF"}
              </div>
            </div>
          </div>
          <button
            onClick={doLogout}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-[#E5E7EB] text-[#6B7280] hover:bg-[#F7F9FC]"
            aria-label="Esci"
            data-testid="logout-button"
          >
            <LogOut size={18} />
          </button>
        </div>
      </div>
    </header>
  );
}
